/**
 * Checkout functionality.
 */

jQuery( $ => {
	/**
	 * Toggles currently selected payment method.
	 */
	function toggleCheckedPaymentMethod() {
		// Remove class on all methods.
		$( '.wc_payment_method' ).removeClass( 'active-payment-method' );
		// Add where radio button is checked.
		$( '.wc_payment_method .input-radio:checked' ).parent().addClass( 'active-payment-method' );
	}

	/**
	 * Set class on parent element of selected checkout payment methods.
	 */
	$( 'body' ).on( 'updated_checkout', function() {
		toggleCheckedPaymentMethod();
		$( '.wc_payment_method input[name="payment_method"]' ).change( toggleCheckedPaymentMethod );
	} );
} );
